<div class="container">
    <button mat-icon-button (click)="previousClicked()" class="left">
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span class="label">{{ periodLabel }}</span>
    <button mat-icon-button (click)="nextClicked()" class="right">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
</div>
